exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.divider-block__container {\n  padding: 12px 0;\n}\n.divider-block__content {\n  height: 1px;\n  background-color: var(--line-divider-default);\n  background-color: var(--line-divider-default);\n}\n", ""]);

// exports
